export const RECEIVE_ERROR = 'RECEIVE_ERROR'
export const CLEAR_ERROR = 'CLEAR_ERROR'
export const FETCH_RESOURCE = 'FETCH_RESOURCE'
